export const CTFRoutes = {
  ctfAdminPage: '/ctf/user',
  ctfAdminStatisticPage: '/ctf/user/statistic'
};
